import { EventPart, PublicEventLocale } from '@hopin-team/api-hopin';
import { TFunction } from '@hopin-team/provider-translation';

export type ReceptionCustomText =
  | 'description'
  | 'explore-booths'
  | 'go-to-networking'
  | 'go-to-stage'
  | 'schedule'
  | 'speakers'
  | 'stage-is-live'
  | 'visit-expo'
  | 'visit-sessions'
  | 'interact-with-people'
  | 'visit-replay'
  | 'visit-url';

export const getEventPartLabel = ({
  t,
  eventPart,
  eventLocale,
  customEventPartTitle,
  appTitle,
  path = 'common',
}: {
  t: TFunction;
  eventPart: EventPart | ReceptionCustomText;
  eventLocale?: PublicEventLocale;
  customEventPartTitle?: string | null;
  appTitle?: string;
  path?: 'common' | 'reception';
}) => {
  const customText =
    eventLocale?.custom_text?.[path]?.[
      eventPart === 'external_url' ? 'external-url' : eventPart
    ];

  if (eventPart === 'app' && appTitle) {
    return appTitle;
  }

  return eventPart === 'custom'
    ? customEventPartTitle || t(eventPart) || ''
    : customText || t(eventPart) || '';
};
